import React, { ReactElement } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import { ParamDataListTypes } from '../../../types/index.ts'
import HumanParamsManipulation from './HumanParamsManipulation/HumanParamsManipulation.tsx'
import chatApi from '../../../api/chatApi/index.ts'
import { useQuery } from 'react-query'

interface Props {
  onHumanClick?: (area_name: string) => void
  onParamClick?: (param_name: string) => void
  paramData: ParamDataListTypes
  onInstrumentSelect?: (instrumentId: number, isCorrect: boolean) => void
}

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'flex-start',
      width: '100%',
      maxWidth: 1800,
      margin: '0 auto',
      flexWrap: 'wrap',
      '& .makeStyles-root-80': {
        width: '100% !important'
      },
      '& .makeStyles-root-103': {
        width: '100% !important',
        [theme.breakpoints.down('md')]: {
          maxWidth: '100% !important'
        }
      }
    }
  })
)

export default function ObjectiveState({
  onHumanClick,
  onParamClick,
  paramData,
  onInstrumentSelect
}: Props): ReactElement {
  const classes = useStyles()

  const currTask: any = useQuery('currTask', () => chatApi.unfinishedTask())

  return (
    <div className={classes.root}>
      <div style={{ width: '80%' }}>
         {currTask?.data?.result?.taskId && (
        <HumanParamsManipulation
          paramData={paramData}
          onParamClick={onParamClick || (() => {})}
          onHumanClick={(event) => onHumanClick?.(event.target.getAttribute('data-area-name') || '')}
          onInstrumentSelect={onInstrumentSelect}
        />
         )}
      </div>
    </div>
  )
}
